import * as core from '../../../../../../../core'
import * as changeImpactType from '../change-impact-type'

export const RESOURCE = {
  payload: {
    description: 'Roles',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactType.RESOURCE.payload.partialId,
    }),
    id: 'Roles',
    name: 'Roles',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
